export default "<a\n  class=\"nav-link\"\n  ng-click=\"vm.activate()\"\n  data-toggle=\"tooltip\"\n  ng-transclude\n>\n</a>\n";